import styles from "./DetailActivityCard.module.css"
import CloseButton from "../../Button/CloseButton/CloseButton";
import { useDetailContext } from '../../../context/DetailContext';
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { getAllProductImages } from "../../../services/productImageService";
import { usePublicCatalog } from "../../../context/PublicCatalogContext";
import { ActivityCardProps } from "../../../types/activity.types";
import SecondaryButton from "../../Button/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../Button/PrimaryButton/PrimaryButton";
import MarkdownMarked from "../../MarkdownMarked/MarkdownMarked";
import bobkova from "../../../assets/images/characters/bobkova_cropped.png"
import ImageCarousel from "../../ImageCarousel/ImageCarousel";
import GalleryCard from "../../Cards/GalleryCard/GalleryCard";
import DatePicker from "../../DatePicker/DatePicker";
import { ChevronDown } from "lucide-react";
import { sendActivity } from "../../../services/activityServices";
import { ActivityQuery } from "../../../services/activityServices";
import { denormalizeDate } from "../../../utils/calendar";
import { log, error as logError } from "../../../utils/logger";
interface DetailActivityCardProps extends ActivityCardProps{
    time?: string,
    date?: string
}

/**
* Detail card for activities items
*
* @param props activitiesItemCardProps
* @param {ActivitiesItem} props.product - Product
* @returns TSX.Element
*/
const DetailActivityCard = ({ product, time, date }: DetailActivityCardProps) => {
    const { t, i18n } = useTranslation(); // Translation
    const {isPublicView, uuid} = usePublicCatalog();
    const {closeDetail} = useDetailContext(); // Detail context

    // Images fore the carousel
    const images = getAllProductImages(product);
    //const images = [food, food, food]

    // Form logic
    const [name, setName] = useState<string>('');
    const [surname, setSurname] = useState<string>('');

    const [email, setEmail] = useState<string>('');
    const [phone, setPhone] = useState<string>('');

    const [company, setCompany] = useState<string>('');
    const [people, setPeople] = useState<number>();

    const [budget, setBudget] = useState<number>();
    const [chosenDate, setChosenDate] = useState<string>('');

    const [note, setNote] = useState<string>('');

    // Centralized errors
    const [errors, setErrors] = useState<Record<string, boolean>>({});
    // Handle date
    const handleDateChange = (value: string[]) => {
        setChosenDate(value[0] ?? ""); // fallback to "" if nothing selected
    };

    // Validate required data
    const validate = () => {
        const next: Record<string, boolean> = {};
            // Required: name
            if (!name) {
                next.name = true;
            }
            // Required: surname
            if (!surname) {
                next.surname = true;
            }
            // Required: email
            if (!email) {
                next.email = true;
            }
            // Required: phone
            if (!phone) {
                next.phone = true;
            }
            // Required: company
            if (!company) {
                next.company = true;
            }
            // Required: people
            if (!people) {
                next.people = true;
            }
            // Required: budget
            if (!budget) {
                next.budget = true;
            }
            // Required: date
            if (!chosenDate) {
                next.date = true;
            }
            setErrors(next);
            return Object.keys(next).length === 0;
    };
    // Send email
    const SendEmail = async () => {
        if (!validate()) return;
        // Payload
        const displayDate = denormalizeDate(chosenDate);
        const activity: ActivityQuery = {
            activity_id: product.id,
            firstname: name,
            lastname: surname,
            company: company,
            email: email,
            phone_number: phone,
            people_count: people ?? 1,
            budget: budget ?? 1000,
            date: displayDate,
            note: note,
        };
        

        try {
            const data = await sendActivity({ activity, uuid });
            //log("Activity sent OK:", data);

            // Clean the fields
            setErrors({});
            setName("");
            setSurname("");
            setEmail("");
            setPhone("");
            setCompany("");
            setPeople(undefined);
            setBudget(undefined);
            setChosenDate("");
            setNote("");

        } catch (err) {
            logError("Failed to send activity:", err);
        }
    };

    return(
        <>
            <div className={styles.ProductDetail} key={product.id}>
                <div className={styles.ProductDetailBlur} onClick={closeDetail}></div>
                <div className={styles.ProductDetailCard}>
                    <div className={styles.ProductMain}>
                        {images.length > 1 ? (
                            <ImageCarousel
                                images={images}
                                className={styles.ProductImage}
                                onPopup={true}
                            />
                        ) : (
                            <GalleryCard imgSrc={images[0]} className={styles.ProductImage} onPopup={true} />
                        )}
                        {/*
                        <GalleryCard imgSrc={getProductImage("" )} className={styles.ProductImage} onPopup={true}/>
                        
                        */}
                        <div className={styles.ProductMainText}>
                            <div className={styles.ProductMainInfo}>
                                <p className={styles.ProductTitle}>{i18n.language === "en" ? product.title_en || "N/A" : product.title}</p>
                                <p className={styles.ProductCat}>
                                    {product.category}
                                </p>
                            </div>
                            <div className={styles.ProductMainActions}>
                                <PrimaryButton
                                    Icon={ChevronDown}
                                    text={t("activities.form.submit")}
                                    disabled={ isPublicView}
                                    onClick={SendEmail}
                                    className={styles.DetailCartButton}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.ProductInfo}>
                        <p className={styles.InfoTitle}>{t("products.desc")}</p>
                        {/*
                        <p className={styles.InfoDescription} >
                            {marked.parse(i18n.language === "en" ? product.text_en || "N/A" : product.text)}
                        </p>
                        */}
                        <MarkdownMarked content={i18n.language === "en" ? product.text_en || "N/A" : product.text}/>
                    </div>
                    <div className={styles.ProductContent}>
                        <div className={styles.ProductOrder}>

                            <div className={styles.ProductOrderLeft}>

                                <div className={styles.ProductOrderLeftTop}>
                                    <p className={styles.ProductOrderLeftTopTitle}>
                                        {t("activities.title")}
                                    </p>
                                    <p className={styles.ProductOrderLeftTopContent}>
                                        {t("activities.subtitle1")} <br/>{t("activities.subtitle2")}
                                    </p>
                                </div>
                                <p className={styles.ProductOrderLeftBottomText}>
                                    {t("activities.email")}
                                    <a href="mailto:catermat@catermat.cz" target="_blank"> catermat@catermat.cz</a>
                                </p>

                                <div className={styles.Character} style={{backgroundImage: `url(${bobkova})`}}></div>

                            </div>

                            <div className={styles.ProductOrderRight}>
                                <div className={styles.ProductOrderRightTop}>

                                    <div className={styles.FormLine}>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.name")}*</p>
                                            <input  
                                            type="text" 
                                            className={`${styles.Input} ${errors.name && !name ? styles.Error : ""}`}
                                            placeholder={t("activities.form.name")}
                                            onChange={(e)=>setName(e.target.value)}
                                            value={name}
                                            />
                                            {(errors.name && !name) && (
                                                <span id="name-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.name")}
                                                </span>
                                            )}
                                        </div>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.surname")}*</p>
                                            <input  
                                            type="text" 
                                            className={`${styles.Input} ${errors.surname && !surname ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.surname")}
                                            onChange={(e)=>setSurname(e.target.value)}
                                            value={surname}
                                            />
                                            {(errors.surname && !surname) && (
                                                <span id="surname-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.surname")}
                                                </span>
                                            )}
                                        </div>
                                        
                                    </div>

                                    <div className={styles.FormLine}>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.email")}*</p>
                                            <input  
                                            type="text" 
                                            className={`${styles.Input} ${errors.email && !email ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.email")}
                                            onChange={(e)=>setEmail(e.target.value)}
                                            value={email}
                                            />
                                            {(errors.email && !email) && (
                                                <span id="email-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.email")}
                                                </span>
                                            )}
                                        </div>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.phone")}*</p>
                                            <input  
                                            type="text" 
                                            className={`${styles.Input} ${errors.phone && !phone ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.phone")}
                                            onChange={(e)=>setPhone(e.target.value)}
                                            value={phone}
                                            />
                                            {(errors.phone && !phone) && (
                                                <span id="phone-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.phone")}
                                                </span>
                                            )}
                                        </div>
                                        
                                    </div>

                                    <div className={styles.FormLine}>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.company")}*</p>
                                            <input  
                                            type="text" 
                                            className={`${styles.Input} ${errors.company && !company ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.company")}
                                            onChange={(e)=>setCompany(e.target.value)}
                                            value={company}
                                            />
                                            {(errors.company && !company) && (
                                                <span id="company-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.company")}
                                                </span>
                                            )}
                                        </div>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.guests")}*</p>
                                            <input  
                                            type="number" 
                                            className={`${styles.Input} ${errors.people && !people ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.guests")}
                                            onChange={(e)=>setPeople(Number(e.target.value))}
                                            value={people ?? ""}
                                            />
                                            {(errors.people && !people) && (
                                                <span id="people-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.guests")}
                                                </span>
                                            )}
                                        </div>
                                        
                                    </div>

                                    <div className={styles.FormLine}>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.budget")}*</p>
                                            <input  
                                            type="number" 
                                            className={`${styles.Input} ${errors.budget && !budget ? styles.Error : ""}`} 
                                            placeholder={t("activities.form.budget")}
                                            onChange={(e)=>setBudget(Number(e.target.value))}
                                            value={budget ?? ""}
                                            />
                                            {(errors.budget && !budget) && (
                                                <span id="budget-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.budget")}
                                                </span>
                                            )}
                                        </div>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.date")}*</p>
                                            {/*
                                            <input  
                                            type="text" 
                                            placeholder={t("activities.form.date")}
                                            onChange={(e)=>setChosenDate(e.target.value)}
                                            value={chosenDate}
                                            className={`${styles.Input} ${errors.date && !date ? styles.Error : ""}`}
                                            />
                                            */}
                                            <DatePicker
                                            className={`${styles.Input} ${styles.DatePicker} ${errors.date && !chosenDate ? styles.Error : ""}`}
                                            wrapperClassName={`${styles.DatePicker}`}
                                            onChange={handleDateChange}
                                            selectedDates={chosenDate ? [chosenDate] : []}
                                            placeholder={t("activities.short_date")}
                                            single={true}
                                            />
                                            {(errors.date && !chosenDate) && (
                                                <span id="date-error" className={styles.ErrorText}>
                                                    {t("activities.form.errors.date")}
                                                </span>
                                            )}
                                        </div>
                                        
                                    </div>

                                    <div className={styles.FormLine}>

                                        <div className={styles.FormGroup}>
                                            <p className={styles.Label}>{t("activities.form.note")}</p>
                                            <textarea  
                                            className={styles.Textarea} 
                                            placeholder={t("activities.form.note_placeholder")}
                                            onChange={(e)=>setNote(e.target.value)}
                                            value={note}
                                            />
                                        </div>
                                        
                                    </div>


                                </div>

                                <div className={styles.ProductOrderRightBottom}>
                                    <SecondaryButton
                                        colorVariant="primary"
                                        text={t("activities.form.submit")}
                                        onClick={SendEmail}
                                        showChevron={false}
                                        className={styles.FormButton}
                                        disabled={isPublicView}
                                    />
                                </div>
                            </div>

                        </div>



                        <div className={styles.ProductsDetails}>
                            <div className={styles.ProductDetailTitle}>
                                <p className={styles.InfoTitle}>{t("products.details")}</p>
                            </div>
                            <div className={styles.ProductDetailContent}>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.place")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.place}
                                    </p>
                                </div>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.enviroment")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.enviroment}
                                    </p>
                                </div>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.time")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.time}
                                    </p>
                                </div>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.guests")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.guest_count}
                                    </p>
                                </div>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.language")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.language}
                                    </p>
                                </div>

                                <div className={styles.ProductDetailContentItem}>
                                    <p className={styles.ProductDetailContentItemTitle}>
                                        {t("products.detail.season")}
                                    </p>
                                    <p className={styles.ProductDetailContentItemContent}>
                                        {product.season}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <CloseButton onClick={()=>closeDetail && closeDetail()} className={styles.Close}/>
                </div>
            </div>
        </>
    )
};

export default DetailActivityCard;
